//region :: Imports ::
import React, {createRef, ReactElement, ReactNode, RefObject} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import {CrewContactData} from '../Api/ControllerTypes/WorkMailTypes';

//endregion

/** */
type Props = {}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    crewContacts: CrewContactData[]
    emails: string[];
    disableAdditional: boolean;
    onOK?: (crewContacts: CrewContactData[], data: string[]) => void;
    addressInput: string;
}

/** */
class EmailConfirmDialog extends MComponent<Props, State> {

    private readonly m_newEmailRef: RefObject<MTextBox>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_newEmailRef = createRef<MTextBox>();

        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.IsEmailInValid = this.IsEmailInValid.bind(this);
        this.AddEmail = this.AddEmail.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            crewContacts: [],
            emails: [],
            disableAdditional: false,
            addressInput: ''
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(crewContacts: CrewContactData[],
                emails: string[],
                inputCallback: (crewContacts: CrewContactData[], data: string[]) => void,
                disableAddional: boolean,
                position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.onOK = inputCallback;
            draft.crewContacts = crewContacts;
            draft.disableAdditional = disableAddional;
            draft.emails = emails;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        this.state.onOK!(this.state.crewContacts, this.state.emails);
        this.hide();
    }

    private IsEmailInValid(){
        if(this.state.addressInput !== null) {
            return !this.state.addressInput!.match(/^([a-z0-9,!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9,!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z]{2,}))(\s*(;|,|\n)\s*[a-z0-9,!#$%&'*+/=?^_`{|}~-]+(\.[a-z0-9,!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*\.([a-z]{2,}))*$/g);
        }

        return true;
    }

    private AddEmail() {
        this.safeSetState(draft => {
            draft.emails.push(String(this.m_newEmailRef.current!.state.value));
            draft.addressInput = '';
        });
        this.m_newEmailRef.current!.setValue('');
    }

    private RemoveEmail(index: number)
    {
        this.safeSetState(draft => {
            draft.emails.splice(index, 1);
        })
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    This will send emails to the following addresses:
                </div>
                <div className="col-12 md:col-12">
                    <table style={{marginTop: 10, marginBottom: 10, marginLeft: 5}}>
                        {this.state.emails.map((element, index) => {
                            return <tr>
                                <td style={{paddingRight: 50}}>
                                    <MButton iconOnly={true} icon={'pi pi-trash'} disabled={false} onClick={this.RemoveEmail.bind(this, index)}/>
                                </td>
                                <td>{element}</td>
                            </tr>;
                        })}
                    </table>
                </div>
                {!this.state.disableAdditional && <React.Fragment>
                    <div className="col-12 md:col-10">
                        <MFormControl label={''} id={'NewEmail'}>
                            {(fieldClasses: string | undefined) => {
                                return (
                                    <MTextBox ref={this.m_newEmailRef}
                                              id={"add email"}
                                              maxLength={50}
                                              initialValue={''}
                                              disabled={false}
                                              onChange={e => this.safeSetState((draft: State) => draft.addressInput = e!.toString())}
                                    />
                                );
                            }}

                        </MFormControl>
                    </div>
                    <div className="col-12 md:col-1">
                        <MFormControl label={' '} id={'AddNew'}>
                            {(fieldClasses: string | undefined) => {
                                return (
                                    <MButton iconOnly={true} icon={'pi pi-plus'} disabled={this.IsEmailInValid} onClick={this.AddEmail}/>
                                );
                            }}
                        </MFormControl>
                    </div>
                </React.Fragment>}
                <div className="col-12 md:col-12">
                    Note: emails to crews with no email address set, will be sent to your own address.
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={false}
                         onClick={this.ok_Click}/>
                <MButton label={'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Send Email'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-pencil', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default EmailConfirmDialog;
